/* Kunjaree: trigger sticky header after 60px scroll */
(function() {
  var headerStickyTargets = document.querySelectorAll('.header__sticky');
  if (!headerStickyTargets.length) return;
  var threshold = 60;
  function updateSticky() {
    var hasSticky = window.scrollY > threshold;
    headerStickyTargets.forEach(function(el) {
      if (hasSticky) el.classList.add('sticky');
      else el.classList.remove('sticky');
    });
  }
  window.addEventListener('scroll', function() { updateSticky(); }, { passive: true });
  window.addEventListener('load', updateSticky);
  if (document.readyState === 'complete') updateSticky();
  else document.addEventListener('DOMContentLoaded', updateSticky);
})();
